import { actionTypes } from "./actionTypeList";

export const setPage = page => ({ 
	type: actionTypes.SET_PAGE,
	payload: { page } 
});

export const setEventCode = eventCode => ({
	type: actionTypes.SET_EVENT_CODE,
	payload: { eventCode }
});